import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import { IDownloadFileRequest } from '../models/download-file.model';

// Open File
export const loadDownloadFile = createAction('[DownloadFile] Load Download File', props<{ request: IDownloadFileRequest }>());

export const loadDownloadFileSuccess = createAction('[DownloadFile] Load Download Success', props<{ response: string }>());

export const loadDownloadFileFailure = createAction(
  '[DownloadFile] Load Download Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
